import { EnumRule } from '@/classes/rules/EnumRule';
import { MinMaxRule } from '@/classes/rules/MinMaxRule';
import { CaseTypeRef, ContractTypeRef } from '@/dto/scenario/ren-fr/revenue/RevenueReference';
import { ObjectRule } from '@/classes/rules/ObjectRule';
import { DefaultValue } from '@/classes/rules/DefaultValue';
import { ScenarioExt } from '@/classes/scenario/ScenarioExt';
import { InjectionModelRef } from '@/dto/scenario/ScenarioReference';
import { ProjectTypeRef } from '@/dto/scenario/ProjectReference';
import { ScenarioRevenueExt } from '@/classes/scenario/ren-fr/revenue/ScenarioRevenueExt';

export const buildRevenueRules = () => new ObjectRule<ScenarioRevenueExt>('revenue', [
  new EnumRule('contractType', ContractTypeRef),
  new EnumRule('caseType', CaseTypeRef),
  new MinMaxRule('ppa1Duration'),
  new MinMaxRule('ppa1RateInflationIndex'),
  new MinMaxRule('ppa1ProductionSold'),
  new MinMaxRule('leaseDuration'),
  new MinMaxRule('selfConsumptionPlantRent'),
  new MinMaxRule('leaseInflation')
])
  .withIsAvailable(scenario => isRenFranceProject(scenario))
  .withDefaultValue(() => new DefaultValue(new ScenarioRevenueExt()));

function isRenFranceProject(scenario: ScenarioExt): boolean {
  return (scenario.project?.typeRef === ProjectTypeRef.ren_fr_pv_project || scenario.project?.typeRef === ProjectTypeRef.ren_fr_wind_project) &&
    scenario.hasInjectionType(InjectionModelRef.total_injection);
}
